import AsyncStorage from '@react-native-async-storage/async-storage';

export interface httpClient {
  method: string | object;
  headers: object;
  body: Body;
}

export const httpClientUser = {
  get: async (url: string) => {

    let finalUrl = `${process.env.BASE_API_USER}/${url}`;
    return callApiRequestTwilio(finalUrl);
  },
  patch: async (url: string, body: object) => {
    let finalUrl = `${process.env.BASE_API_USER}/${url}`;
    const httpClientConfig = await getHttpClientConfig('PATCH', body);
    return callApiRequest(finalUrl, httpClientConfig);
  },
};

export const httpClientAgent = {
  get: async (url: string) => {
    let finalUrl = `${process.env.BASE_API_AGENT}/${url}`;
    return callApiRequestTwilio(finalUrl);
  },

  create: async (url: string, body: object) => {
    let finalUrl = `${process.env.BASE_API_AGENT}/${url}`;
    const httpClientConfig = await getHttpClientConfig('POST', body);
    return callApiRequest(finalUrl, httpClientConfig);
  },
  patch: async (url: string, body: object) => {
    let finalUrl = `${process.env.BASE_API_AGENT}/${url}`;
    const httpClientConfig = await getHttpClientConfig('PATCH', body);
    return callApiRequest(finalUrl, httpClientConfig);
  },
  put: async (url: string, body: object) => {
    let finalUrl = `${process.env.BASE_API_AGENT}/${url}`;
    const httpClientConfig = await getHttpClientConfig('PUT', body);
    return callApiRequest(finalUrl, httpClientConfig);
  },
};

export const httpClientDocument = {
  get: async (url: string, params: any, isDocument = false) => {
    let uri = '';
    if (params) {
      uri = new URLSearchParams(params).toString();
    }

    let finalUrl = `${process.env.BASE_API_AGENT}/${url}`;
    const httpClientConfig = await getHttpClientConfig('GET');

    if (!isDocument) {
      return callApiRequest(finalUrl, httpClientConfig);
    } else {
      return callApiRequestDocument(finalUrl, httpClientConfig);
    }
  },
  create: async (url: string, body: object) => {
    let finalUrl = `${process.env.BASE_API_AGENT}/${url}`;
    const httpClientConfig = await getHttpClientConfig('POST', body, true);

    return callApiRequest(finalUrl, httpClientConfig);
  },
};

const callApiRequest = (url: string, httpClientConfig: object) => {
  return fetch(url, httpClientConfig)
    .then(async response => {
      console.log('------------ RESPONSE -------------');
      if (response.status == 204 || response.status == 404) {
        return Promise.reject("no_content");
      }

      let data = await response.json();
      let status = response.status;

      if (status == 200) {
        return Promise.resolve(data);
      } else {
        if (data.message_id) {
          return Promise.reject(data.message_id);
        } else if (data.error) {
          return Promise.reject(data.error);
        } else if (data.details) {
          return Promise.reject(data.details[0].msg);
        } else {
          return Promise.reject('Request failed, try again.');
        }
      }
    })
    .catch(error => {
      return Promise.reject(error ? error.toString() : 'Error call request');
    });
};

const callApiRequestDocument = (url: string, httpClientConfig: object) => {
  return fetch(url, httpClientConfig)
    .then(response => response.blob())
    .then(response => {
      console.log('------------ RESPONSE -------------');
      //console.log(`${response.status} <-- ${httpClientConfig.method}:  ${url}`);

      return Promise.resolve(response);
    })
    .catch(error => {
      return Promise.reject(error ? error.toString() : 'Error call request');
    });
};

const callApiRequestTwilio = (url: string) => {
  return fetch(url)
    .then(async response => {
      if (response.status == 204 || response.status == 404) {
        //console.log(`${response.status} <-- ${httpClientConfig.method}:  ${url}`);
        return Promise.reject("no_content");
      }

      let data = await response.json();
      let status = response.status;

      if (status == 200) {
        return Promise.resolve(data);
      } else {
        if (data.message_id) {
          return Promise.reject(data.message_id);
        } else if (data.error) {
          return Promise.reject(data.error);
        } else if (data.details) {
          return Promise.reject(data.details[0].msg);
        } else {
          return Promise.reject('Request failed, try again.');
        }
      }
    })
    .catch(error => {
      return Promise.reject(error ? error.toString() : 'Error call request');
    });
};

const getHttpClientConfig = async (
  method: string | object,
  body: object | null = null,
  isDocument = false,
) => {
  const headers = {
    Accept: 'application/json',
    'Content-Type': "",
    Authorization: "",
  };

  if (isDocument) {
   headers['Content-Type'] = `multipart/form-data`;
  } else {
    headers['Content-Type'] = `application/json`;
  }

  // if (token && token.length > 10) {
  //   headers['Authorization'] = `Bearer ${token}`;
  // }

  let finalBody: any = body;
  if (!isDocument && body) {
    finalBody = JSON.stringify(body);
  }

  return {
    method: method,
    headers: isDocument? {}:headers,
    body: finalBody,
  };
};
